import './TicketRefundModal.scss';
import DefaultModal from '../defaultModal/DefaultModal';
import useTranslation from '../../../../hooks/translation/useTranslation';
import DefaultButton from '../../buttons/defaultButton/DefaultButton';
import { refundTicket } from '../../../../../services/customer/ticketServices';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';

function TicketRefundModal({ refundModal, setRefundModal, fetchTickets }) {
  const { data, show } = refundModal;
  const { setShowErrorModal, setTicketRefundConfirmModal } = useModal();
  const { trans } = useTranslation();

  const handleClose = () => {
    setRefundModal({
      show: false,
      data: [],
    });
  };

  const handleConfirm = async () => {
    try {
      const res = await refundTicket({
        ride_id: data?.ticket?.ride_id,
        seat_number: data?.ticket?.seat_number,
        statement_id: data?.ticket?.statement.statement_id,
        ticket_id: data?.ticket?.id,
        wagon_number: data?.ticket?.wagon_number,
      });
      if (res.status === 'success') {
        await fetchTickets();
        setTicketRefundConfirmModal({
          show: true,
          data: {
            ticketId: data?.ticket?.ticket_number,
          },
        });
      } else {
        setShowErrorModal(trans('error_try_30m_later'));
      }
    } catch (e) {
      if (e.response.data.status === 'expired' || e.response.data.message) {
        switch (e.response.data.message) {
          case 'external_statement':
            setShowErrorModal(trans('external_statement_refund_error'));
            break;
          case 'refund_amount_exceeds':
            setShowErrorModal(trans('refund_amount_exceeds_error'));
            break;

          default:
            setShowErrorModal(trans('refund_not_possible'));
            break;
        }
      } else {
        setShowErrorModal(trans('error_try_30m_later'));
      }
    }

    handleClose();
  };

  return (
    <DefaultModal
      show={show}
      setShow={handleClose}
      className="ticket-refund-modal"
    >
      <div className="flex flex-col gap-5">
        <h3 className="text-center">
          {trans('you_will_refund_x')?.replace(
            '{x}',
            `${data?.priceAmount} ${data?.currency}`,
          )}
        </h3>
        <div className="flex justify-between items-center">
          <DefaultButton className="!bg-gray-gr py-3" onClick={handleClose}>
            {trans('reject')}
          </DefaultButton>
          <DefaultButton
            className={`py-3 ${data?.percentage === 0 && 'cursor-not-allowed'}`}
            onClick={handleConfirm}
            disabled={data?.percentage === 0}
          >
            {trans('confirm')}
          </DefaultButton>
        </div>
      </div>
    </DefaultModal>
  );
}

export default TicketRefundModal;
